import { makeStyles } from "@mui/styles";
import diagonalLines from "../../../assets/svg/diagonalLines.svg";
import { palette } from "../../../theme/palette";
import { getHeatmapColor } from "../../../utils/map";

const useStyles = makeStyles({
  invisibleBorders: {
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
  },
  invisiblePostcode: {
    fontSize: "12px",
    padding: "0px 4px",
    color: "transparent",
    border: "1px solid transparent",
  },
  background: {
    position: "absolute",
    height: "32px",
    width: "100%",
    marginTop: "-26px",
    marginLeft: "-4px",
  },
  borders: {
    position: "absolute",
    marginTop: "-22px",
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
    boxShadow: "1px 1px",
  },
  postcode: {
    fontSize: "12px",
    padding: "0px 4px",
    border: "1px solid black",
  },
});

export const ArtificialPostcodesTile = ({
  postcode,
  selectedRoute,
  zoomLevel,
  streetView,
  heatmapView,
  artificialFeatures,
  multiPostcodeFeatures,
}) => {
  const styles = useStyles();
  const { colour, textColour, routeCode, totalStops } =
    artificialFeatures[postcode] || {};
  const multi =
    !heatmapView && !!multiPostcodeFeatures?.[zoomLevel]?.[postcode];

  const routeStyle = {
    backgroundColor: heatmapView
      ? getHeatmapColor(totalStops)
      : colour || palette.typography.white.solid,
    color: !heatmapView && textColour ? textColour : palette.black,
    opacity:
      streetView || (selectedRoute && routeCode !== selectedRoute.routeCode)
        ? 0.3
        : 0.8,
  };

  return (
    <>
      <div className={styles.invisibleBorders}>
        <div className={styles.invisiblePostcode}>{postcode}</div>
      </div>
      <div
        className={styles.background}
        style={{
          backgroundColor: routeStyle.backgroundColor,
          backgroundImage: multi && `url(${diagonalLines})`,
          opacity: routeStyle.opacity,
        }}
      />
      <div className={styles.borders}>
        <div className={styles.postcode} style={{ color: routeStyle.color }}>
          {postcode}
        </div>
      </div>
    </>
  );
};
